// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"118": "lib-router","361": "lib-react",}[chunkId] || chunkId) + "." + {"118": "d3234740","361": "ce0dcc27","527": "055ce666","67": "a09e14ce","72": "509736f0","981": "1cb15ce3",}[chunkId] + ".js"
}